
import { AuthLayout, Register } from "../components/authComponents"

function RegisterPage() {
    return (
        <AuthLayout>
            <Register />
        </AuthLayout>
    );
}

export default RegisterPage;